import { render, staticRenderFns } from "./ldapSynchronizationGroups.vue?vue&type=template&id=a3817338"
import script from "./ldapSynchronizationGroups.vue?vue&type=script&lang=js"
export * from "./ldapSynchronizationGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports